<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h4>First Time Login</h4>

      <p>If this is the first time you are logging into the app (mobile number does not exist in the Data Center you
        selected), you will be asked to provide your Display Name.</p>


      <ol class="Vlt-list Vlt-list--simple">
        <li>
          <div>Fill in your Full Name.</div>
          <div><span style="font-style: italic;">Note: This name will be visible to other users.</span></div>
          <img src="https://vids.vonage.com/pages/inapp-android/image4.jpg" width="240" alt="image4"
            style="height: 160px; object-fit: cover; object-position: 50% 100%;" />
        </li>
        <li>
          <span>Click on the&nbsp;</span>
          <span style="padding-left: 4px; padding-right: 4px; background-color: #e6e6e6;">Setup User</span>
          <span>&nbsp;button to complete the User Setup Process.</span>
        </li>
      </ol>
    </div>

  </section>

</template>

<script lang="js">
export default {
  name: 'demo',
  components: {
  },
  props: {
    nexmo: {
      type: Object,
      required: false
    }
  },
}
</script>

<style scoped lang="scss"></style>